import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  BoltIcon,
  LockClosedIcon,
  UserGroupIcon,
  DocumentPlusIcon,
} from '@heroicons/react/24/outline'
import { Text, Button, Heading } from '../ui'

const patternBg =
  "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"

const DashboardOrientacaoSection: React.FC = () => {
  const navigate = useNavigate()

  return (
    <section className="h-full py-0">
      <article className="overflow-hidden rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-md h-full flex flex-col">
        {/* Banner hero */}
        <div
          className="relative flex items-center overflow-hidden px-4 py-3 sm:px-5 sm:py-3.5"
          style={{ background: 'linear-gradient(135deg, #115e59 0%, #008B95 60%, #2dd4bf 100%)' }}
        >
          <div
            className="pointer-events-none absolute inset-0"
            style={{ backgroundImage: patternBg }}
            aria-hidden
          />
          <div className="relative flex w-full min-w-0 items-center justify-between gap-3">
            <div className="min-w-0 flex-1">
              <Heading
                as="h3"
                size="xl"
                className="!text-white text-[1.15rem] sm:text-xl font-extrabold leading-snug tracking-tight drop-shadow-sm line-clamp-3"
              >
                Departamento de Qualidade
              </Heading>
            </div>
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => navigate('/qualidade/tickets')}
              className="flex-shrink-0 bg-white ring-white/40 hover:bg-gray-100 !px-3.5 !py-1.5 text-xs font-semibold"
            >
              <DocumentPlusIcon className="h-3.5 w-3.5 mr-1 shrink-0" aria-hidden />
              Registrar ocorrência ou sugestão
            </Button>
          </div>
        </div>

        {/* Corpo */}
        <div className="px-5 py-2.5 sm:px-6 flex-1 flex flex-col justify-between">
          <div className="flex items-start gap-4">
            <div className="flex-1 min-w-0">
              <Text size="sm" weight="medium" className="text-gray-900 dark:text-white mb-0.5">
                Sua visão melhora tudo.
              </Text>
              <br />
              <Text size="sm" className="text-gray-600 dark:text-gray-300 leading-snug">
                Identificou algo fora do padrão ou teve uma ideia?
                <br />
                Registre aqui e contribua com a melhoria contínua
                <br />
                dos nossos processos.
              </Text>
            </div>
            <img
              src="/qualidade.png"
              alt="Ilustração de colaboração e melhoria contínua"
              style={{ height: '8rem', width: 'auto', maxWidth: '8rem', objectFit: 'contain', flexShrink: 0 }}
            />
          </div>

          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-gray-400 dark:text-gray-500 mt-2">
            <span className="inline-flex items-center gap-1">
              <BoltIcon className="h-3.5 w-3.5 shrink-0 text-primary-500" aria-hidden />
              Rápido
            </span>
            <span aria-hidden>·</span>
            <span className="inline-flex items-center gap-1">
              <LockClosedIcon className="h-3.5 w-3.5 shrink-0 text-primary-500" aria-hidden />
              Confidencial
            </span>
            <span aria-hidden>·</span>
            <span className="inline-flex items-center gap-1">
              <UserGroupIcon className="h-3.5 w-3.5 shrink-0 text-primary-500" aria-hidden />
              Colaborativo
            </span>
          </div>
        </div>
      </article>
    </section>
  )
}

export default DashboardOrientacaoSection
